import { GameState } from '@bg-shared/enums';
import { IGameStatusModel } from './interfaces';

export const gamesStatusSelectors = {
    getOpenForBets: (state: IGameStatusModel) => state.openForBets,

    getStarted: (state: IGameStatusModel) => state.started,

    isMaintenance: (state: IGameStatusModel) => state.state === GameState.MAINTENANCE,
};
